module.exports = __webpack_public_path__ + "img/zhanweitu@2x.0ae5478f.png";